import { Component, type ReactNode } from 'react';

interface Props {
	children: ReactNode;
	fallback: ReactNode;
}

interface State {
	hasError: boolean;
}

export class RelayErrorBoundary extends Component<Props, State> {
	state: State = { hasError: false };

	static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	render(): ReactNode {
		return this.state.hasError ? this.props.fallback : this.props.children;
	}
}
